import { Drawer as MuiDrawer } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Drawer
 *
 * A styled MUI Drawer component with responsive width and background color.
 * Accepts an `isMobile` prop to adjust maxWidth for desktop vs mobile.
 *
 * @param {boolean} isMobile - Whether the drawer is rendered on a mobile device
 */
export const Drawer = styled(MuiDrawer)<{ isMobile: boolean }>(
    ({ theme, isMobile }) => ({
        flexShrink: 0,
        "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: "fit-content",
            minWidth: "200px",
            maxWidth: "400px",
            // Ensure smooth transitions
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.short,
            }),
            // Prevent horizontal overflow
            ...(!isMobile && {
                maxWidth: "40vw",
            }),
            backgroundColor: "rgb(216, 220, 227)",
        },
    }),
);

/**
 * DrawerContentWrapper
 *
 * A styled div that wraps the content inside the drawer, enforcing min/max width constraints.
 */
export const DrawerContentWrapper = styled("div")(() => ({
    width: "fit-content",
    minWidth: "200px",
    maxWidth: "100%",
}));

/**
 * DrawerHeader
 *
 * A styled div for the drawer header, aligning content and applying toolbar spacing.
 */
export const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
}));
